export const ALLOWED_IMG_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const MAX_BYTES = 8 * 1024 * 1024;
export const MAX_ORDER_IMAGES = 20;
export const MAX_ITEMS = 50;
export const PHONE_RE = /^\+?\d{8,15}$/;
export const BANK_ACCOUNT_RE = /^\d{4}\.\d{2}\.\d{5}$|^\d{11}$/;
export const POSTAL_CODE_RE = /^\d{4}$/;
export const MOBILE_QUERY = "(max-width: 820px)";
export const STEP_PARAM = "steg";

export const STEPS = [
  { label: "Kontaktinformasjon", nextLabel: "Neste" },
  { label: "Registrer gjenstander", nextLabel: "Jeg har lagt til alle gjenstander jeg vil selge" },
  { label: "Stener og perler", nextLabel: "Se oppsummering og fullfør" },
  { label: "Oppsummering", nextLabel: "Fullfør og bestill gullkonvolutt" },
] as const;

export const PHOTO_GUIDANCE =
  "Hvis du ønsker å selge mer enn en gjenstand, trenger du kun et bilde av alt. Se til at alt er separert og godt synlig på bildet. Vi legger automatisk til en beskrivelse av hver gjenstand etter at bildet er lagt til. Sjekk at beskrivelsen av gjenstanden samsvarer med bildet.";

// The empty state leads with the call to action; once there are items the guidance moves below the
// photo buttons and drops it, so the two share everything but the opening sentence.
export const PHOTO_INTRO = `Legg ved eller ta et bilde av det du ønsker å selge. ${PHOTO_GUIDANCE}`;

export const HELP_LINES = [
  "Etter registrering mottar du en gullkonvolutt i posten fra oss. Pakk gjenstandene forsvarlig før de legges i den medfølgende forsikrede konvolutten.",
  "Velg foretrukket returmetode via Postenappen.",
  "Når vi mottar pakken din vil vi veie og teste innholdet i hver gjenstand.",
  "Du mottar så et tilbud som du vil finne her på min side, vi varsler deg på e-post når det er klart.",
  "Du velger utbetaling til bankkonto, gavekort hos David-Andersen eller å få gjenstandene i retur.",
];
